export default __webpack_public_path__ + "static/media/close_circle.0ec5b321.svg";